import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './styles/globals.css'

// Sync Telegram WebApp theme - only toggle dark class
function initTelegramTheme() {
  const webApp = (window as any).Telegram?.WebApp
  if (!webApp) return

  webApp.ready()
  webApp.expand()

  const applyTheme = () => {
    const root = document.documentElement
    root.classList.toggle('dark', webApp.colorScheme === 'dark')
  }

  applyTheme()
  webApp.onEvent('themeChanged', applyTheme)
}

initTelegramTheme()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
